__turbopack_context__.v({
  "button": "CalculatorTabs-module-scss-module__RNnH_a__button",
  "selected": "CalculatorTabs-module-scss-module__RNnH_a__selected",
  "tabs": "CalculatorTabs-module-scss-module__RNnH_a__tabs",
});
